const module = {
  namespaced: true,

  state: {
    /*
     * Culture actuellement mise en valeur dans les graphiques de repartition.
     *
     * L'etat est partage plutot que local a chaque carte : survoler une culture
     * dans un graphique doit allumer la meme culture dans les graphiques des
     * autres cartes de la page. C'est un etat d'interface, pas une donnee
     * metier, d'ou sa place dans le magasin de l'application.
     */
    codeCultureMiseEnValeur: null
  },

  getters: {
    version: () => `v${process.env.VUE_APP_VERSION}`,
    codeCultureMiseEnValeur: (state) => state.codeCultureMiseEnValeur
  },

  mutations: {
    UPDATE_CODE_CULTURE_MISE_EN_VALEUR (state, codeCultureMiseEnValeur) {
      state.codeCultureMiseEnValeur = codeCultureMiseEnValeur
    }
  },

  actions: {
    mettreEnValeurCulture ({ commit }, codeTypeCulture) {
      commit('UPDATE_CODE_CULTURE_MISE_EN_VALEUR', codeTypeCulture)
    }
  }
}

export default module
